//
//
//
//
//
//

export default {
  name: 'BaseBanner',

  props: {
    size: {
      type: String,
      default: 'small',
      validator(value) {
        return ['small', 'medium', 'large'].includes(value)
      }
    }
  },

  computed: {
    bannerClasses() {
      return [`is-${this.size}`]
    }
  }
}
